module.exports = __webpack_public_path__ + "img/papel-higienico.05f99c65.png";